import * as React from 'react';

export const useCssState = (url: string): 'loading' | 'ready' | 'error' => {
  const [cssState, setCssState] = React.useState<
    | {
        status: 'loading';
        element: HTMLLinkElement;
      }
    | {
        status: 'ready';
      }
    | {
        status: 'error';
      }
  >(() => {
    const linkElement = document.querySelector(
      'link[href="' + url + '"]'
    ) as HTMLLinkElement | null;
    if (!linkElement) {
      return { status: 'error' };
    }
    if (linkElement.sheet) {
      return { status: 'ready' };
    }
    return { status: 'loading', element: linkElement };
  });

  React.useLayoutEffect(() => {
    if (cssState.status !== 'loading') {
      return;
    }

    function setReady() {
      setCssState({ status: 'ready' });
      this.removeEventListener('load', setReady);
      this.removeEventListener('error', setError);
    }
    function setError() {
      setCssState({ status: 'error' });
      this.removeEventListener('load', setReady);
      this.removeEventListener('error', setError);
    }
    cssState.element.addEventListener('load', setReady);
    cssState.element.addEventListener('error', setError);
  }, []);
  return cssState.status;
};
